import * as Sentry from '@sentry/browser';
const returnFirstArg = (x) => x;
const TOKEN = 'Xm4faXb5SijhFRLlIPnHh6MZmXMpIUHH';
export default class Service {
  constructor(api, options = {}) {
    this.api = api;
    this.api.use({
      headers: {
        'Access-Token': TOKEN,
      },
    });
    const { afterParser = returnFirstArg } = options;
    this.afterParser = afterParser;
    this.retriesLimit = options.retriesLimit;
  }

  async find(params, retries = 0) {
    try {
      const response = await this.api.get(params);
      return this.afterParser(response);
    } catch (err) {
      if (this.retriesLimit && retries < this.retriesLimit) {
        return this.find(params, retries + 1);
      }
      Sentry.captureException(err);
      // Re-throw o erro original (não encapsula em new Error) para preservar
      // status code, response e demais propriedades que os handlers precisam
      throw err;
    }
  }

  async update(data = {}, options = {}) {
    try {
      const response = await this.api.post(data, options);
      return this.afterParser(response);
    } catch (err) {
      Sentry.captureException(err);
      throw err;
    }
  }

  async modify(data = {}, options = {}) {
    try {
      const response = await this.api.patch(data, options);
      return this.afterParser(response);
    } catch (err) {
      Sentry.captureException(err);
      throw err;
    }
  }

  async insert(data = {}, options = {}) {
    try {
      const response = await this.api.put(data, options);
      return this.afterParser(response);
    } catch (err) {
      Sentry.captureException(err);
      throw err;
    }
  }

  async remove(params = {}) {
    try {
      const response = await this.api.delete(params);
      return this.afterParser(response);
    } catch (err) {
      Sentry.captureException(err);
      throw err;
    }
  }
}
